module.exports = __webpack_public_path__ + "img/case_beihang_university.b956fa27.png";